import { BASE_API_URL } from 'lib/setting';
import { axs } from './config/axiosConfig';

const basePath = `${BASE_API_URL}/auth`;
// const userPath = `${BASE_API_URL}/user`;

// auth
export function signInAuth(payload: object | any) {
  return axs({ url: `${basePath}/connect`, method: 'post', data: payload });
}

export function signUpAuth(payload: object | any) {
  return axs({ url: `${basePath}/signup`, method: 'post', data: payload });
}

// TODO: 신규계정 테스트 필요
export function editLegalAgreement(payload: {
  policy: string;
  accessToken: string;
  userTypeIdx: number;
}) {
  console.log('payload : ', payload);

  return axs({ url: `${basePath}/agreement`, method: 'put', data: payload });
}

export function editAuthProfile(payload: { return_url: string; failure_url: string }) {
  return axs({ url: `${basePath}/modify`, method: 'post', data: payload });
}

export function editAuthPassword() {
  return axs({ url: `${basePath}/password/change`, method: 'post' });
}

export function checkGroupCode(payload: { groupCode: string; email: string }) {
  return axs({ url: `${basePath}/groupcode/check`, method: 'post', data: payload });
}

export function connectAuthProfile(payload: { groupCode: string; email: string }) {
  return axs({ url: `${basePath}/token/connect`, method: 'post', data: payload });
}

// TODO: Sync 서비스의 약관 동의 유무확인을 위한 API 추가
